exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".el-row[data-v-71f3cb2e]{margin-bottom:10px}.el-row[data-v-71f3cb2e]:last-child{margin-bottom:0}.el-notification .el-icon-warning[data-v-71f3cb2e]{color:#e74c3c}", "", {"version":3,"sources":["/Users/zeedog/Documents/Projects/zeedog-oms/theme/zeedog-omb-vue/src/components/receivables/Receivables.vue"],"names":[],"mappings":"AACA,yBAAyB,kBAAkB,CAC1C,AACD,oCAAoC,eAAe,CAClD,AACD,mDAAmD,aAAa,CAC/D","file":"Receivables.vue","sourcesContent":["\n.el-row[data-v-71f3cb2e]{margin-bottom:10px\n}\n.el-row[data-v-71f3cb2e]:last-child{margin-bottom:0\n}\n.el-notification .el-icon-warning[data-v-71f3cb2e]{color:#E74C3C\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-71f3cb2e","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/receivables/Receivables.vue
// module id = 542
// module chunks = 0